export const checkAll = (text) => {
            try {
                text = text.replace(/\n/g, ' ').replace(/\\n/g, ' ').split(' ');
                let utrList = [], utr = '';
                for (let i = 0; i < text.length; i++) {
                    if(text[i].length == 12 || text[i].length == 10) {
                        utrList.push(text[i]);
                    }
                }

                for (let i = 0; i < utrList.length; i++) {
                    if(!utr || (utr && utr.length == 10)) {
                        if(!isNaN(utrList[i]) && utrList[i].length == 12) {
                            utr = utrList[i];
                        } else if(!isNaN(utrList[i]) && utrList[i].length == 10) {
                            utr = utrList[i];
                        }
                    } else {
                        break;
                    }
                }
                return utr;
            } catch (e) {
                return false
            }
        };